export default {
  // role: {
  //   en: 'Role',
  //   pt: 'Função',
  //   he: 'Role',
  // },
  tasks: {
    en: 'Main tasks',
    pt: 'Principais funções',
    he: 'Main tasks',
  },
};
